module.exports = __webpack_public_path__ + "img/3.cc5d5636.png";